//[IMPORT] Util function
import {_rafThrottle} from '../../../util';

//for Internet Explorer 11
const isIE = /*@cc_on!@*/false || !!document.documentMode;
const THROTTLE_WAIT = isIE ? 100 : 0;

const SCROLL_FLAG = 'data-scroll'

export default {
    props:{
        initLeft: { type: Number, default:0 },
    },
    data() {return {
        scrAcc: 0,
        refRowsMap : {},
        refFrzsMap : {},
        headerHeight : this.gridInfo.opts.headerHeight
    }},
    computed: {
        // [COMPUTED][STYLE] Style of contents
        contStyle() {
            var summaryHeight = this.gridInfo.slot['summary']?this.gridInfo.opts.summaryHeight:0;
            return {height:`calc(100% - ${this.headerHeight + summaryHeight}px)`}
        },
    },
    mounted() {
        // 1. set refs
        this.gridInfo.func.setRefs('scrollWrapper',this.$refs.scrollWrapper);
        this.gridInfo.func.setRefs('freezeWrapper',this.$refs.freezeWrapper);
        if(this.$refs.pScroll){
            this.gridInfo.func.setRefs('pseudoScroll',this.$refs.pScroll);
        }
        // 2. Event bus!
        // 2.1 Resize column...
        this.gridInfo.eventBus.$on('recalc-width',()=>{
            this.updatePseudoScroll();
        })
        // 2.2 Scroll
        this.gridInfo.eventBus.$on('set-scroll-top',(n)=>{
            this.vScrollTop = n;
            this.setScrollTop(n);
        })
        this.gridInfo.eventBus.$on('set-scroll-left',(n,m,l)=>{
            this.setScrollLeft(n,m,l);
        })
        // 3. Row refs
        // 3.1 Build refs map
        this.buildRefs();

        if(this.gridInfo.slot['header']){
            this.headerHeight = this.gridInfo.refs.header.getBoundingClientRect().height;
        }
        if(this.initLeft > 0) {
            this.setScrollLeft(this.initLeft);
        }
    },
    updated() {
        this.updatePseudoScrollY();
        // NO-X
    },
    beforeDestroy() {
        const header = this.gridInfo.refs.scrollHeader;
        if(header.scrollLeft > 0) {
            this.$emit('before-destroy', header.scrollLeft);
        }
    },
    methods : {
        buildRefs() {
            // 1. rows
            this.refRowsMap = {};
            if(this.$refs.refRows) {
                this.$refs.refRows.forEach(rComp => {
                    this.refRowsMap[rComp.row.__id] = rComp;
                })
            }
            // 2. freezes
            this.refFrzsMap = {};
            if(this.$refs.refFrzs) {
                this.$refs.refFrzs.forEach(rComp => {
                    this.refFrzsMap[rComp.row.__id] = rComp;
                })
            }
        },
        updatePseudoScroll() {
            this.updatePseudoScrollX();
            this.updatePseudoScrollY();
        },
        onWheelFixed(e) {

            // 1. check top/bottom && prevent default
            const MARGIN = 10;//px
            var sw = this.$refs.scrollWrapper, scroll = sw.scrollTop+this.scrAcc+e.deltaY,
                mst = MARGIN, med = sw.scrollHeight-sw.clientHeight-MARGIN;
            // 2. No height, No need sync.
            if(!this.gridInfo.opts.height && sw.scrollHeight <= sw.clientHeight) {return;}
            // 3. block default action
            if( mst <= scroll && scroll <= med) {
                e.preventDefault();
            }
            // 4. save delta & got to sync scroll
            this.scrAcc += e.deltaY;
            this.syncFreezeScroll(e);
        },
        syncFreezeScroll: _rafThrottle(function(e){
            // 1. prevent default action -> Wheel, Scroll...
            var scr = this.$refs.scrollWrapper,
                st = scr.scrollTop,
                sh = scr.scrollHeight,
                ch = scr.clientHeight;
            if(0 < st && st < sh-ch) {
                e.preventDefault();
                e.stopPropagation();
            }

            // 2. Set Scroll Top
            this.setScrollTop(scr.scrollTop + this.scrAcc)
            this.scrAcc = 0;
            // x. Etc works.
            this.gridInfo.func.setHeaderContext(null);
        }),
        // [METHODS] Set manual scroll top.
        setScrollTop (scrollTop, isPseudoSkip) {
            const sw = this.gridInfo.refs.scrollWrapper
                , fw = this.gridInfo.refs.freezeWrapper
                , rw = this.gridInfo.refs.selectWrapper
                , ftoolt = this.gridInfo.refs.freezeTooltip
                , stoolt = this.gridInfo.refs.scrollTooltip;
            // 0. Previous top
            const prevTop  = sw.scrollTop,
                  eMARGIN = this.gridInfo.opts.scrollEventMargin;
            // 1. Set scroll & scroll
            var ST = scrollTop < 0 ? 0 : scrollTop;
            sw.scrollTop = ST;
            if(!!fw) {fw.scrollTop = ST}
            if(!!rw) {rw.scrollTop = ST}

            var sh = sw.scrollHeight,
                ch = sw.clientHeight,
                scrollMax = sh-ch;
            /** tooltip-scroller의 margin-top값이
             * scrollHeight - clientHeight 를 넘지 않도록 처리
             */
            if( ST >  scrollMax) {
                ST = scrollMax;
            }

            if(stoolt) {
                stoolt.style['margin-top'] = `-${ST}px`;
            }
            if(ftoolt) {ftoolt.style['margin-top'] = `-${ST}px`;}
            // 2. Check scroll
            if(!isPseudoSkip) {
                this.updatePseudoScrollY();
            }
            // 3. Event for vertical end
            var sScr  = sw.scrollHeight,
                sRect = sw.getBoundingClientRect();
            if(prevTop !== ST && ST <= 0) {
                this.gridInfo.func.fireEvent('scroll-top')
            }
            if(prevTop!==ST && (ST+sRect.height) >= sScr*((100-eMARGIN)/100)) {
                this.gridInfo.func.fireEvent('scroll-bottom')
            }

            // x. onScroll
            this.onScroll();

            return ST;
        },
        // [METHODS] Set manual scroll left.
        setScrollLeft (scrollLeft, isPseudoSkip, isSelectClearSkip) {
            const scroll = this.$refs.scrollWrapper
                , freeze = this.$refs.freezeWrapper
                , feader = this.gridInfo.refs.freezeHeader
                , header = this.gridInfo.refs.scrollHeader
                , stoolt = this.gridInfo.refs.scrollTooltip;

            if(scroll) scroll.scrollLeft = scrollLeft;
            if(header) header.scrollLeft = scrollLeft;
            if(stoolt) {
                stoolt.style['margin-left'] = `-${scrollLeft}px`;
            }
            if(feader && freeze) {
                feader.setAttribute(SCROLL_FLAG,scroll.scrollLeft?0:1)
                freeze.setAttribute(SCROLL_FLAG,scroll.scrollLeft?0:1)
            }

            this.gridInfo.eventBus.$emit('update-cell-select', scrollLeft);

            // x. clear selection
            if(!isSelectClearSkip) {
                //this.gridInfo.func.clearCellSelect();
            }
            // x. pseudo scroll
            if(!isPseudoSkip) {
                this.updatePseudoScrollX();
            }
            // x. onScroll -> After scrolling task
            this.onScroll();
            // x. return
            return scrollLeft;
        },
        // [METHODS] Do something after scrolling
        onScroll() {
            var scroll = this.$refs.scrollWrapper
            if(!scroll) return;
            // 1. remove context
            this.gridInfo.func.setHeaderContext(null);
            // 2. scroll event
            // 2.1 Fire scroll event
            this.gridInfo.func.fireEvent('scroll', scroll.scrollLeft, scroll.scrollTop)
        },
        // [METHOD][RENDER] FORCE!!
        forceRender() {
            window.requestAnimationFrame(() => {
                this.$forceUpdate()
            })
        },
        // [METHOD][SCROLL] for pseudo scroll !!!
        onPseudoScroll({posx, maxx, posy, maxy, offset, offsetX, offsetY}) {
            var sw = this.$refs.scrollWrapper;
            if(posx>=0 && maxx) {
                this.setScrollLeft(~~((sw.scrollWidth-sw.clientWidth) * posx / maxx));
            } else if(posy>=0 && maxy) {
                var nextPos = ~~((sw.scrollHeight-sw.clientHeight) * posy / maxy)
                this.__posy = nextPos;
                this.setScrollTop(nextPos, true);
            } else if(offset || offsetY) { // use offset
                this.setScrollTop(sw.scrollTop + (offset||offsetY));
            } else if(offsetX) { // use offset
                this.setScrollLeft(sw.scrollLeft + offsetX);
            }
        },
        refreshPseudoScroll(direction){
            var sw = this.$refs.scrollWrapper;
            if(direction?.toUpperCase() === 'Y')  this.setScrollTop(sw.scrollTop);
            else if(direction?.toUpperCase() === 'X')  this.setScrollLeft(sw.scrollLeft);
        },
        updatePseudoScrollX() {
            var sw = this.$refs.scrollWrapper;
            if(!sw) return;
            if(!this.$refs['pScroll']) return;
            this.$refs['pScroll'].setScrollX({
                pos:sw.scrollLeft,
                max:sw.scrollWidth,
                win:sw.clientWidth
            })
        },
        updatePseudoScrollY(fromToggleRow) {
            var sw = this.$refs.scrollWrapper;
            if(!sw || (!fromToggleRow && this.__posy === sw.scrollTop))return;
            if(!this.$refs['pScroll']) return;
            this.$refs['pScroll'].setScrollY({
                pos:sw.scrollTop,
                max:sw.scrollHeight,
                win:sw.clientHeight
            })
        }
    }
}
